import { FC, HTMLAttributes } from 'react';
import { twMerge } from 'tailwind-merge';

import { StripeLogoIcon } from '../../icons';

export const PoweredByStripe: FC<HTMLAttributes<HTMLDivElement>> = ({ className, ...props }) => (
  <div className={twMerge('flex gap-1', className)}>
    <p className="text-sm font-medium text-neutral-700">Powered by</p>
    <StripeLogoIcon />
  </div>
);
